export const vickyMainInteractions = [
    {
        id: 1,
        label: 'Talk',
        disabled: false
    },
    {
        id: 2,
        label: 'Date',
        disabled: true
    },
    {
        id: 3,
        label: 'Make love',
        disabled: true
    },
    {
        id: 4,
        label: '(Interact...)',
        disabled: true
    }
]

export const vickyDateInteractions = [
    {
        id: 5,
        label: 'Jogging',
        disabled: false
    },
    {
        id: 6,
        label: 'Training together',
        disabled: true
    },
    {
        id: 7,
        label: 'Beach',
        disabled: true
    },
]
